<header class="modal-header fondo-bg">
  <div class="modal-title text-center text-white h3 w-100">
    <img [src]="confirmarRespuesta.imagen" width="50" />
    Importante
</div>
</header>
<section class="modal-body text-center">
  <header class="row text-center">
    <label class="h5 col text-body"><strong>{{confirmarRespuesta.type}}</strong></label>
  </header>
  <footer class="row">
    <p class="text-muted col-12">{{confirmarRespuesta.message}}</p>
  </footer>
</section>
<footer class="modal-footer">
  <div class="col-12 row d-flex justify-content-center">
    <button class="btn w-25 btn-primary" (click)="confirm()">{{confirmarRespuesta.buttonTextAlert}}</button>
  </div>
</footer>

